import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BaseApiService } from './base-api.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  constructor(private router:Router, private baseAPI: BaseApiService, private spinnerService: Ng4LoadingSpinnerService) {
  }
  logout(){
    localStorage.setItem('token','');
    this.router.navigate(['/login']);
   // this.logout();
    }
    logoutAPI() {
     
      this.baseAPI.callLogoutApi( this.baseAPI.logoutURL).then(data => {
      
     this.spinnerService.hide();
           
    }, (err) => {
  
        
      
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts